import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import ErrorAlert from '../../components/widgets/ErrorAlert';
import HeadingWithIcon from '../../components/widgets/HeadingWithIcon';
import LoadingSpinner from '../../components/widgets/LoadingSpinner';
import SuccessAlert from '../../components/widgets/SuccessAlert';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import API from "../../network/ApiCall";
import { FONTAWESOME_VARIANT } from '../../config';
import copy from "copy-to-clipboard";
import { format, parseISO } from 'date-fns';

const APIKeys = (props) => {

  const APIKEYS_ENDPOINT = "/apikey";

  const { t } = useTranslation();

  const [formState, setFormState] = useState({ success: false, errorMessage: null, submissionDate: null });
  const [keyData, setKeyData] = useState();
  const [loading, setLoading] = useState(true);


  const loadKeys = async (id) => {
    setLoading(true);
    try {
      const response = await API.get(APIKEYS_ENDPOINT);
      setKeyData(response.data);
      setLoading(false);
    } catch (error) {
      console.error("ERROR LOADING ACCOUNT: ", error);
      setLoading(false);
    };
  };

  useEffect(() => {
    loadKeys();
  }, []);

  const generateKey = () => {
    API.post(APIKEYS_ENDPOINT + "/generate").then(response => {
      if (response.data) {
        setKeyData(response.data);
        setFormState({ success: true, error: null, submissionDate: new Date() });
      } else {
        setFormState({ success: false, error: "Error in response", submissionDate: new Date() });
      }
    })
      .catch(error => {
        setFormState({ success: false, error: t("common:msgUnknownApiError"), submissionDate: new Date() });
      })
  }

  const deactivateKey = (key) => {

    API.patch(APIKEYS_ENDPOINT + "/deactivate/" + key).then(response => {
      loadKeys();
    })
      .catch(error => {
        setFormState({ success: false, error: t("common:msgUnknownApiError"), submissionDate: new Date() });
      })

  }

  const deleteKey = (key) => {
    // eslint-disable-next-line no-restricted-globals
    if (confirm((t('common:msgAreYouSure')))) {
      API.delete(APIKEYS_ENDPOINT + "/" + key).then(response => {
        loadKeys();
      })
        .catch(error => {
          setFormState({ success: false, error: t("common:msgUnknownApiError"), submissionDate: new Date() });
        })
    }
  }

  const reactivateKey = (key) => {
    API.patch(APIKEYS_ENDPOINT + "/reactivate/" + key).then(response => {
      loadKeys();
    })
      .catch(error => {
        setFormState({ success: false, error: t("common:msgUnknownApiError"), submissionDate: new Date() });
      })

  }

  const copyToClipboard = (text) => {
    copy(text);
    alert(t("apikeys:msgKeyCopied"));
  }

  return (
    <>

      <div className="content p-4">

        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item"><Link to="/">{t('dashboard:hdgHeading')}</Link></li>
            <li className="breadcrumb-item active" aria-current="page">{t('apikeys:hdgHeading')}</li>
          </ol>
        </nav>
        <div className="m-2 m-sm-5">


          <div className="card my-5">
            <div className="card-header ">
              <div className="row">
                <div className="col">
                  <HeadingWithIcon icon="fa-key">{t('apikeys:hdgHeading')}</HeadingWithIcon>
                </div>
              </div>
            </div>
            <div className="card-body ">

              <div className="row ">

                <div className="col-xs-12 col-xl-9 offset-xl-1 mb-5">



                  {formState.success && <SuccessAlert message={t('apikeys:msgNewKeySuccess')} lastStateUpdate={formState.submissionDate} />}
                  <ErrorAlert error={formState.error} lastStateUpdate={formState.submissionDate} />

                  {loading ? <LoadingSpinner /> : <div className='table-responsive'>

                    {!keyData?.length ? <button className='btn btn-primary w-100 mt-5' onClick={generateKey}>{t('apikeys:btnGenerate')}</button> :
                      <>
                        <table className='table fs-5'>
                          <thead>
                            <tr>
                              <th>#</th>
                              <th>{t('apikeys:lblKey')}</th>
                              <th>{t('apikeys:lblDateCreated')}</th>
                              <th className='text-center'>{t('apikeys:lblActive')}</th>
                              <th className='text-end'>{t('apikeys:lblActions')}</th>
                            </tr>
                          </thead>
                          <tbody>
                            {keyData.map((key, index) => <tr key={key.id}>
                              <td>{index + 1}</td>
                              <td>{key.id}

                                <OverlayTrigger placement="top" overlay={<Tooltip placement="top" className="in" id="tooltip-top">
                                  {t('apikeys:ttCopyToClipboard')}
                                </Tooltip>}><span>
                                    <button className='btn btn-link' onClick={() => { copyToClipboard(key.id) }}><i className={FONTAWESOME_VARIANT + " fa-clone"} /></button>
                                  </span></OverlayTrigger>

                              </td>
                              <td className='fw-3'>{format(parseISO(key.createdAt, 'yyyy-MM-d'), 'd/MM/yyyy')}</td>
                              <td className='text-center fw-3'>{key.active && <i className={FONTAWESOME_VARIANT + " fa-check"} />}</td>
                              <td className='text-end'>
                                <div>
                                  {key.active ? <>
                                    <OverlayTrigger placement="top" overlay={<Tooltip placement="top" className="in" id="tooltip-top">
                                      {t('apikeys:ttDeactivateKey')}
                                    </Tooltip>}><span>
                                        <button className='btn btn-link text-success' onClick={() => deactivateKey(key.id)}><i className={"fa fa-toggle-on"} /></button>
                                      </span></OverlayTrigger>
                                  </> : <OverlayTrigger placement="top" overlay={<Tooltip placement="top" className="in" id="tooltip-top">
                                    {t('apikeys:ttReactivateKey')}
                                  </Tooltip>}><span>
                                      <button className='btn btn-link text-danger' onClick={() => reactivateKey(key.id)}><i className={"fa fa-toggle-off"} /></button>
                                    </span></OverlayTrigger>}

                                  <OverlayTrigger placement="top" overlay={<Tooltip placement="top" className="in" id="tooltip-top">
                                    {t('apikeys:ttDeleteKey')}
                                  </Tooltip>}><span>
                                      <button className='btn btn-link text-danger' onClick={() => deleteKey(key.id)}><i className={FONTAWESOME_VARIANT + " fa-trash"} /></button>
                                    </span></OverlayTrigger>
                                </div>
                              </td>
                            </tr>
                            )}
                          </tbody>
                        </table>
                        <button className='btn btn-outline-primary mt-3' onClick={generateKey}>{t('apikeys:btnGenerateNew')}</button>

                      </>
                    }
                  </div>}


                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default APIKeys;